export {TermsPage} from './terms/terms.page';
export {NotFoundPage} from './not-found/not-found.page';
export {PrivacyPolicyPage} from './privacy-policy/privacy-policy.page';
